import type { ContentProps } from '@workspace/core-ts/types';

export default {
    title: {
        site: (
            <>
                Informations sur votre <b>société</b>
            </>
        ),
        courtier: (
            <>
                Informations sur la <b>société de votre client</b>
            </>
        ),
    },
    inputLabel: {
        site: 'N° de SIREN (Ex : 123 456 789)',
        courtier: 'N° de SIREN de votre client (Ex: 123 456 789)',
    },
} as unknown as ContentProps;
